module.exports = __webpack_public_path__ + "src/assets/fonts/glyphicons-halflings-regular.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/glyphicons-halflings-regular.woff
// module id = 33
// module chunks = 0